import React from 'react'

const PhoneGreenSvg = ({ width }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} viewBox='0 0 18 17'>
      <path
        id='phone-svgrepo-com_2_'
        data-name='phone-svgrepo-com (2)'
        d='M16.556,12.906l-.455.453s-1.083,1.076-4.038-1.862-1.872-4.015-1.872-4.015l.287-.285a2.023,2.023,0,0,0,.157-2.654L9.373,2.859a2.075,2.075,0,0,0-3.112-.284L4.692,4.136A2.118,2.118,0,0,0,4,5.746c.09,1.586.808,5,4.812,8.981,4.247,4.223,8.231,4.39,9.861,4.238A2.18,2.18,0,0,0,20,18.3l1.421-1.412a2.06,2.06,0,0,0-.538-3.255l-1.911-1.039A2.039,2.039,0,0,0,16.556,12.906Z'
        transform='translate(-4 -2)'
        fill='#b5ccc2'
      />
    </svg>
  )
}

export default PhoneGreenSvg
